import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=461317d2&scoped=true&"
import script from "./Exception.ts?vue&type=script&lang=ts&"
export * from "./Exception.ts?vue&type=script&lang=ts&"
import style0 from "./Exception.css?vue&type=style&index=0&id=461317d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461317d2",
  null
  
)

export default component.exports